(function ($) {

    function validateEmail(email) {
        const re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    $('.newsletter-category').each(function (index, el) {
        $(this).select2({
            closeOnSelect: true,
            minimumResultsForSearch: $(this).data('search-results'),
            placeholder: $(this).data('input-placeholder')
        })
    });

    $('.form-box .category-select').each(function (index, el) {
        $(this).select2({
            closeOnSelect: true,
            minimumResultsForSearch: -1,
            placeholder: $(this).data('input-placeholder')
        })
    });

    $('.submit-newsletter').on('click', function () {
        let valid = true;
        let form = $(this).closest('form[name="newsletter"]');
        let errorMessage = form.find('.error-message');
        let errorMessageGeneric = form.find('.error-message-generic');
        let successMessage = form.find('.success-message');
        let emailInput = form.find('input[name="user-email"]');
        let nameInput = form.find('input[name="user-name"]');
        let categorySelect = form.find('select[name="newsletter-category"]');
        let privacyCheckbox = form.find('input[name="newsletter-privacy-policy"]');
        let token = form.find('.captcha-token').val();
        let button = $(this);

        form.find('.error').removeClass('error');
        errorMessage.removeClass('active');
        errorMessageGeneric.removeClass('active');
        successMessage.removeClass('active');

        if ((emailInput.val().trim() === '') || !validateEmail(emailInput.val().trim())) {
            valid = false;
            emailInput.addClass('error');
            errorMessage.addClass('active');
        }

        if ((nameInput.val().trim() === '')) {
            valid = false;
            nameInput.addClass('error');
            errorMessage.addClass('active');
        }

        if (categorySelect.val().trim() === '') {
            valid = false;
            categorySelect.next().addClass('error');
            errorMessage.addClass('active');
        }

        if (!privacyCheckbox[0].checked) {
            valid = false;
            privacyCheckbox.closest('.custom-checkbox-wrap').addClass('error');
            errorMessage.addClass('active');
        }

        if (valid) {
            button.addClass('loading');

            var data = {
                'action': 'mailerlite_register',
                'email': emailInput.val().trim(),
                'name': nameInput.val().trim(),
                'category': categorySelect.val().trim(),
                'acceptance': privacyCheckbox[0].checked,
                'token': token
            };

            $.get(postmpwp.ajax_url, data, function (response) {
                button.removeClass('loading');

                if (response.success) {
                    if (response.data.error) {
                        errorMessageGeneric.addClass('active');
                    } else {
                        successMessage.addClass('active');
                        emailInput.val('');
                        nameInput.val('');
                        privacyCheckbox[0].checked = false;
                        categorySelect.val('').trigger('change');
                    }
                } else {
                    errorMessage.addClass('active');

                    if (response.data === "email") {
                        emailInput.addClass('error');
                    }

                    if (response.data === "name") {
                        nameInput.addClass('error');
                    }

                    if (response.data === "category") {
                        categorySelect.next().addClass('error');
                    }

                    if (response.data === "acceptance") {
                        privacyCheckbox.closest('.custom-checkbox-wrap').addClass('error');
                    }
                }
            });
        }
    });

})(jQuery);